import { omit } from 'lodash';
import createAction from '../../services/create-action';
import { loadTranslations } from '../../services/translations-getter';
import { getExperimentValue } from '../../../app/selectors/experiments-selectors';

export const FETCH_TRANSLATIONS_REQUEST = 'posts/FETCH_TRANSLATIONS_REQUEST';
export const FETCH_TRANSLATIONS_SUCCESS = 'posts/FETCH_TRANSLATIONS_SUCCESS';
export const FETCH_TRANSLATIONS_FAILURE = 'posts/FETCH_TRANSLATIONS_FAILURE';
export const SET_TRANSLATIONS = 'posts/SET_TRANSLATIONS';

export const setTranslations = createAction(SET_TRANSLATIONS);
export const fetchTranslationsRequest = createAction(FETCH_TRANSLATIONS_REQUEST);
export const fetchTranslationsSuccess = createAction(FETCH_TRANSLATIONS_SUCCESS);
export const fetchTranslationsFailure = createAction(FETCH_TRANSLATIONS_FAILURE);

export function fetchTranslations(language) {
  return (dispatch, getState, { appParams, httpClient }) => {
    dispatch(fetchTranslationsRequest());

    const translationsPromise = loadTranslations({
      baseUrl: appParams.baseUrls.translationsBaseUrl,
      translationsName: 'main',
      language,
      httpClient,
    });

    return translationsPromise.then(
      (body) => {
        const state = getState();
        const isReadonly =
          getExperimentValue(state, 'specs.forum.enableGroupsMigration') === 'restricted';
        const translations = isReadonly ? body : omit(body, 'empty-state.commenting-locked-text'); // Sorry :(
        return dispatch(fetchTranslationsSuccess(translations));
      },
      () => dispatch(fetchTranslationsFailure()),
    );
  };
}

export function setCommentsTranslations(commentsApi) {
  return (dispatch) => {
    const translationsState = commentsApi.watch.translations.getCurrent() || {};
    dispatch(setTranslations(translationsState.translations));
  };
}
